import axios from 'axios';
import store from '../../store/index';

export default {
	getLastStatistics(year) {
		return axios.post('/api/statistics/last', { year });
	},
	getStatistics(date, users) {
		return axios.post('/api/statistics', { from: date, to: date, users });
	},
};
